import React, { FC } from 'react';

import { normalizedTranslate } from '@rbilabs/components-library';
import styled from 'styled-components';

const Heading = styled.div`
  text-align: center;
  margin-block-end: 1.8rem;
  margin-block-start: 1.8rem;

  ${Styles.desktop} {
    margin-block-end: 2.5rem;
    margin-block-start: 2.5rem;
  }
`;

const Header = styled.h1`
  font-family: ${Styles.fontFamily.brand};
  font-size: 2rem;
  color: ${Styles.color.tertiary};
  font-weight: normal;
  letter-spacing: -2px;
  line-height: 90%;
  margin: 0;
  margin-block-end: -1.6rem;
  text-shadow: none;
  transform-origin: bottom;
  transform: rotate(-5deg) ${normalizedTranslate(0, '-10%')};

  ${Styles.desktop} {
    margin-block-end: -2.2rem;
    font-size: 2.7rem;
    transform: rotate(-5deg) ${normalizedTranslate(0, '-30%')};
  }
`;

const Subheader = styled.h2`
  color: ${Styles.color.black};
  line-height: 1;
  margin-block-end: 0;
`;

type IMenuSectionDualHeadingProps = {
  heading: string;
  subheading: string;
};

const MenuSectionDualHeading: FC<IMenuSectionDualHeadingProps> = ({ heading, subheading }) => (
  <Heading>
    <Header>{heading}</Header>
    <Subheader>{subheading}</Subheader>
  </Heading>
);

export default MenuSectionDualHeading;
